import React, { useEffect } from "react";

import styled from "@emotion/styled";
import shallow from "zustand/shallow";

import Modal from "../../../CallForTender/components/AddressModal/Modal";
import useCheckoutStore from "../../Checkout/store";
import useShopStore from "../../store";
import ShippingPriceList from "./ShippingPriceList";

const Content = styled.div`
    max-height: 40vh;
    padding-right: 1em;
    padding-left: 1em;
    overflow: scroll;
`;

const ShippingMethod = styled.div`
    margin-bottom: 2em;
`;

const ShippingPriceListModal = () => {
    const { shippingMethods, fetchShippingMethods } = useCheckoutStore(
        (state) => ({
            fetchShippingMethods: state.fetchShippingMethods,
            shippingMethods: state.shippingMethods,
        }),
        shallow
    );
    const { isVisible, setIsVisible } = useShopStore(
        (state) => ({
            isVisible: state.isShippingInfoModalVisible,
            setIsVisible: state.setIsShippingInfoModalVisible,
        }),
        shallow
    );

    useEffect(() => {
        if (shippingMethods.length < 1) {
            const fetchData = async () => {
                await fetchShippingMethods();
            };
            void fetchData();
        }
    }, []);

    return (
        <Modal
            headline="Versandkosten"
            isActive={isVisible}
            closeButton="Schließen"
            handleClose={() => setIsVisible(false)}
            actionRow={false}
        >
            <Content className="shipping-price-modal-content">
                {shippingMethods.map((method) => (
                    <ShippingMethod key={method.id}>
                        <strong>{method.name}</strong>
                        <div>{method.description}</div>
                        <ShippingPriceList priceList={method.prices} />
                    </ShippingMethod>
                ))}
            </Content>
        </Modal>
    );
};

const ShippingCostLink = styled.span`
    color: ${({ theme }) => theme.colors.blue.toString()};
    text-decoration: underline;

    &:hover {
        cursor: pointer;
    }
`;

// Use this Link-Component to add the modal functionality anywhere
export const ShippingInfoModalActivator = ({ hasFreeShipping = false }) => {
    const { setIsVisible } = useShopStore(
        (state) => ({
            setIsVisible: state.setIsShippingInfoModalVisible,
        }),
        shallow
    );

    const onShippingInfoClicked = (event: React.BaseSyntheticEvent) => {
        event.stopPropagation();
        setIsVisible(true);
    };

    return (
        <div>
            inkl. MwSt. {hasFreeShipping && <span>Versandkostenfrei</span>}
            {!hasFreeShipping && (
                <ShippingCostLink onClick={onShippingInfoClicked}>
                    zzgl. Versandkosten
                </ShippingCostLink>
            )}
        </div>
    );
};

export default ShippingPriceListModal;
